/**
 * Deep links into the production Grafana (Loki), for superuser support tools.
 */

const GRAFANA_URL = 'https://grafana.baintex.com';
const LOKI = { type: 'loki', uid: 'loki' };

/** A LogQL string literal: the uid must not be able to close the quotes. */
function logqlString(value: string) {
    return `"${value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
}

/**
 * Grafana Explore with the last 24 h of a device's logs: what its firmware
 * uploads (log_type="minihub", one readable line per entry) and what the
 * realtime gateway logs about it (connections, orders, errors).
 */
export function grafanaDeviceLogsUrl(uid: string) {
    const filter = `|= ${logqlString(uid)}`;
    const panes = {
        device: {
            datasource: LOKI.uid,
            queries: [
                {
                    refId: 'device',
                    datasource: LOKI,
                    expr: `{compose_project="sentiorealtime", log_type="minihub"} ${filter}`
                        + ' | logfmt | line_format "{{.ts}} [{{.dev_level}}] {{.tag}}: {{.text}}"',
                },
                {
                    refId: 'gateway',
                    datasource: LOKI,
                    expr: `{compose_project="sentiorealtime", log_type!="minihub"} ${filter}`,
                },
            ],
            range: { from: 'now-24h', to: 'now' },
        },
    };
    const params = new URLSearchParams({
        schemaVersion: '1',
        panes: JSON.stringify(panes),
        orgId: '1',
    });
    return `${GRAFANA_URL}/explore?${params.toString()}`;
}
